import React from "react";

import { animated } from "@react-spring/web";

import { ProgressProps } from "./types";
import { useProgress } from "./hooks";

export const Progress = (props: ProgressProps) => {
  const { getCabinProps, getCarProgressProps, getWheelProps, getWindProps } =
    useProgress(props);
  return (
    <animated.div {...getCarProgressProps()}>
      <img {...getCabinProps()} />
      <img {...getWindProps()} />
      <animated.img {...getWheelProps()} />
      <animated.img {...getWheelProps()} />
    </animated.div>
  );
};
